// src/app/modules/ers-leave-management/dialogs/preview-details-dialog/preview-details-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-preview-details-dialog',
  standalone: true,
  imports: [
    TranslocoPipe,CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './preview-details-dialog.component.html',
  styleUrls: ['./preview-details-dialog.component.scss']
})
export class PreviewDetailsDialogComponent {
  
  constructor(
    public dialogRef: MatDialogRef<PreviewDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  get isCompOff(): boolean {
    return this.data.type === 'COMP_OFF';
  }

  get isOptional(): boolean {
    return this.data.type === 'OPTIONAL_HOLIDAY';
  }
}